import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import FocusCorners from "./FocusCorners";

const StyledButton = styled("div")(({ theme }) => ({
  height: "140px",
  width: "320px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  letterSpacing: "0.08em",
  transition: "all 318ms ease-in-out",
  cursor: "pointer",
  borderRadius: "0",
  userSelect: "none",
  color: "#fff",
  border: "0.5px solid #323232",
  "--stroke-color": "#323232",

  "& .focus-corners": {
    "--corner-margin": "20px"
  },
  "&:hover": {
    color: "#fff",
    "--stroke-color": "#323232",

    "& .focus-corners": {
      "--corner-color": "#fff",
      "--corner-margin": "4px"
    }
  },
  "&:active": {
    transform: "scale(0.97)"
  },
  "&.active": {
    background: ` rgba(255, 135, 54, 0.4)`,
    "background-blend-mode": "soft-light, normal, normal",
    color: "#FF8736",
    "--stroke-color": "#FF8736",

    "& .focus-corners": {
      "--corner-color": "#FF8736",
      "--corner-margin": "10px"
    }
  },

  [theme.breakpoints.down("sm")]: {
    height: "60px",
    width: "100%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    fontSize: "14px",
    lineHeight: "normal",
    textAlign: "left",
    letterSpacing: "0.08em",
    transition: "all 318ms ease-in-out",
    cursor: "pointer",
    borderRadius: "0",
    userSelect: "none",
    color: "#fff",
    border: "0.5px solid #323232",
    "--stroke-color": "#323232",

    "& .focus-corners": {
      "--corner-margin": "4px"
    },
    "&.active": {
      // background: ` rgba(255, 135, 54, 0.4)`,
      // "background-blend-mode": "soft-light, normal, normal",
      // color: "#FF8736",
      // "--stroke-color": "#FF8736",

      // "& .focus-corners": {
      //   "--corner-color": "#FF8736",
      //   "--corner-margin": "4px"
      // },
      // transform: "scale(0.97)",
      background: ` rgba(255, 135, 54, 0.4)`,
      "background-blend-mode": "soft-light, normal, normal",
      color: "#FF8736",
      "--stroke-color": "#FF8736",

      "& .focus-corners": {
        "--corner-color": "#FF8736",
        "--corner-margin": "4px"
      }
    }
  }
}));

const FocusGhostLargeButton = ({ children, ...props }) => {
  return (
    <StyledButton {...props}>
      <FocusCorners>{children}</FocusCorners>
    </StyledButton>
  );
};

export default FocusGhostLargeButton;
